import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { filter, map, take } from 'rxjs';

export const projectsGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return authService.currentUser$.pipe(
    filter((user) => !!user),
    take(1),
    map((user) =>
      user?.rules?.every(
        (rule) =>
          ![
            UserRule.projectAdmin,
            UserRule.projectEditing,
            UserRule.projectManagement,
            UserRule.projectDownloading,
            UserRule.projectUploading,
          ].includes(rule),
      )
        ? router.parseUrl('error?code=403')
        : true,
    ),
  );
};
